import React from "react";
import { useLocation, Outlet, useNavigate } from "react-router-dom";
import { Typography, Box, Tabs, Tab, Alert } from "@mui/material";
import { useAppSelector } from "../../store/hooks";
import { selectExtension } from "../../features/extension/extension.selector";

const TABS = [
  { label: "My Details", path: "/account" },
  { label: "Billing", path: "/account/billing" },
  { label: "Plans", path: "/account/subscriptions" },
];

export const AccountSettingsWrapper = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isExtension } = useAppSelector(selectExtension);

  return (
    <Box>
      <Typography variant="h1" sx={{ mb: "8px" }}>
        Account Settings
      </Typography>
      <Tabs
        value={location.pathname.replace("/payment-success", "")}
        onChange={(event: React.SyntheticEvent, newValue: string) => {
          event.preventDefault();
          navigate(newValue);
        }}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
      >
        {TABS.map((tab, index) => (
          <Tab label={tab.label} key={index} value={tab.path} />
        ))}
      </Tabs>
      <Box
        maxWidth={1000}
        mx="auto"
        pt={isExtension ? 1.5 : 5}
        pb={isExtension ? 1.5 : 2}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default AccountSettingsWrapper;
